"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function ({params}) {
        this.state = { student: !params ? false : null };
    },
    onMount: function () {
        this.fetchStudent(this.input.params.id);
    },
    fetchStudent: async function (id) {
        try {
            const {error, message, student} = await Request(`/insight/student/${ id }`);
            if (error)
                throw new Error(message);
            this.state.student = student;
        } catch (error) {
            console.log('Failed fetching user: ', error);
            this.state.student = false;
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Users/Instructor/Students/View/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    LoadingPage_template = require("../../../../../components/LoadingPage.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    LoadingPage_tag = marko_loadTag(LoadingPage_template),
    Locale_template = require("../../../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Image_template = require("../../../../../../components/Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    marko_forIn = require("marko/dist/runtime/helpers/for-in"),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Row_template = require("../../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    WSAdapt_template = require("../../../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    Tabs_template = require("../../../../../components/Tabs.marko"),
    Tabs_tag = marko_loadTag(Tabs_template),
    Wrapper_Admin_template = require("../../../../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template),
    marko_attrs0 = {
        "class": "d-flex align-items-center",
        style: "height:50vh"
      },
    marko_attrs1 = {
        "class": "w-100 text-center"
      },
    marko_attrs2 = {
        "class": "row"
      },
    marko_attrs3 = {
        "class": "col-3 d-flex justify-content-center"
      },
    marko_attrs4 = {
        "class": "col"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("cadd2f"),
    marko_node0 = marko_createElement("br", null, "13", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs5 = {
        "class": "font-medium-5 mb-50"
      },
    marko_attrs6 = {
        "class": "text-muted"
      },
    marko_attrs7 = {
        "class": "my-3"
      },
    marko_attrs8 = {
        "class": "px-1 py-75 border-top"
      },
    marko_attrs9 = {
        "class": "font-medium-2 float-right text-muted"
      },
    marko_attrs10 = {
        "class": "my-3"
      },
    marko_attrs11 = {
        "class": "mb-4"
      },
    marko_attrs12 = {
        "class": "card-content"
      },
    marko_attrs13 = {
        "class": "card-body"
      },
    marko_attrs14 = {
        "class": "card-text overflow-hidden font-medium-4"
      },
    marko_attrs15 = {
        "class": "font-small-3 text-muted text-ellipsis mb-0"
      },
    marko_attrs16 = {
        "class": "my-3"
      },
    marko_attrs17 = {
        "class": "mb-4"
      },
    marko_attrs18 = {
        "class": "card-content"
      },
    marko_attrs19 = {
        "class": "card-body"
      },
    marko_attrs20 = {
        "class": "card-text overflow-hidden font-medium-4"
      },
    marko_attrs21 = {
        "class": "font-small-3 text-muted text-ellipsis mb-0"
      };

const Tabs = {
	"enrollments": {
		"anchor": "#enrollments",
		"title": "Enrollments",
		"component": require('./tabs/Enrollments.marko')
	},
	"learning_paths": {
		"anchor": "#learning-paths",
		"title": "Learning Paths",
		"component": require('./tabs/LearningPaths.marko')
	},
	"assignments": {
		"anchor": "#assignments",
		"title": "Assignments",
		"component": require('./tabs/Assignments.marko')
	},
	"assessments": {
		"anchor": "#assessments",
		"title": "Assessments",
		"component": require('./tabs/Assessments.marko')
	},
	"achievements": {
		"anchor": "#achievements",
		"title": "Achievements",
		"component": require('./tabs/Achievements.marko')
	}
};

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_Admin_tag({
      class: "position-relative w-100 h-100",
      renderBody: function(out, { themeMode }) {
        if (state.student === null) {
          LoadingPage_tag({}, out, __component, "1");
        } else if (state.student === false) {
          out.be("div", marko_attrs0, "2", component);

          out.be("div", marko_attrs1, "3", component);

          Locale_tag({
              text: "Student Not Found"
            }, out, __component, "4");

          out.ee();

          out.ee();
        } else {
          const { profile, account, learner } = state.student

          Row_tag({
              class: "px-2",
              renderBody: function(out) {
                WSAdapt_tag({
                    class: "col-3",
                    renderBody: function(out) {
                      out.be("section", marko_attrs2, "7", component);

                      const fullname = getFullname( profile )

                      out.be("div", marko_attrs3, "8", component);

                      Image_tag({
                          alt: fullname,
                          src: profile.photo,
                          style: "width:6rem;height:6rem",
                          class: "avatar"
                        }, out, __component, "9");

                      out.ee();

                      out.e("div", marko_attrs4, "10", component, 2)
                        .e("h4", marko_attrs5, "11", component, 1)
                          .t(fullname, component)
                        .e("p", marko_attrs6, "12", component, 1)
                          .t(profile.email, component);

                      out.ee();

                      out.n(marko_node0, component);

                      if (profile.super) {
                        out.be("section", marko_attrs7, "14", component);

                        marko_forIn(profile.super, function(key, value) {
                          var $keyValue$0 = "@" + key,
                              $keyScope$0 = "[" + ($keyValue$0 + "]");

                          out.be("div", marko_attrs8, $keyValue$0, component);

                          Locale_tag({
                              text: key.toCapitalCase(),
                              class: "font-medium-2"
                            }, out, __component, "15" + $keyScope$0);

                          out.e("span", marko_attrs9, "16" + $keyScope$0, component, 1)
                            .t(value, component);

                          out.ee();
                        });

                        out.ee();
                      }

                      if (Array.isArray(learner.departments) && learner.departments.length) {
                        out.be("section", marko_attrs10, "17", component);

                        out.be("h6", marko_attrs11, "18", component);

                        Locale_tag({
                            text: "Departments",
                            class: "text-muted"
                          }, out, __component, "19");

                        out.ee();

                        var $for$0 = 0;

                        marko_forOf(learner.departments, function({ departmentId, poster, name, description }) {
                          var $keyScope$1 = "[" + (($for$0++) + "]");

                          out.be("div", {
                              href: "/department/" + departmentId,
                              "class": "my-25 card"
                            }, "20" + $keyScope$1, component);

                          out.be("div", marko_attrs12, "21" + $keyScope$1, component);

                          Row_tag({
                              class: "no-gutters",
                              col: [
                                  {
                                      class: "col-lg-3 col-sm-4 col-12",
                                      renderBody: function(out) {
                                        Image_tag({
                                            alt: name,
                                            src: poster,
                                            class: "h-100 w-100 rounded-left"
                                          }, out, __component, "24" + $keyScope$1);
                                      }
                                    },
                                  {
                                      class: "col-lg-9 col-sm-8 col-12",
                                      renderBody: function(out) {
                                        out.e("div", marko_attrs13, "26" + $keyScope$1, component, 2)
                                          .e("div", marko_attrs14, "27" + $keyScope$1, component, 1)
                                            .t(name, component)
                                          .e("div", marko_attrs15, "28" + $keyScope$1, component, 1)
                                            .t(description, component);
                                      }
                                    }
                                ]
                            }, out, __component, "22" + $keyScope$1);

                          out.ee();

                          out.ee();
                        });

                        out.ee();
                      }

                      if (Array.isArray(learner.categories) && learner.categories.length) {
                        out.be("section", marko_attrs16, "29", component);

                        out.be("h6", marko_attrs17, "30", component);

                        Locale_tag({
                            text: "Categories",
                            class: "text-muted"
                          }, out, __component, "31");

                        out.ee();

                        var $for$1 = 0;

                        marko_forOf(learner.categories, function({ categoryId, poster, name, description }) {
                          var $keyScope$2 = "[" + (($for$1++) + "]");

                          out.be("div", {
                              href: "/category/" + categoryId,
                              "class": "my-25 card"
                            }, "32" + $keyScope$2, component);

                          out.be("div", marko_attrs18, "33" + $keyScope$2, component);

                          Row_tag({
                              class: "no-gutters",
                              col: [
                                  {
                                      class: "col-lg-3 col-sm-4 col-12",
                                      renderBody: function(out) {
                                        Image_tag({
                                            alt: name,
                                            src: poster,
                                            class: "h-100 w-100 rounded-left"
                                          }, out, __component, "36" + $keyScope$2);
                                      }
                                    },
                                  {
                                      class: "col-lg-9 col-sm-8 col-12",
                                      renderBody: function(out) {
                                        out.e("div", marko_attrs19, "38" + $keyScope$2, component, 2)
                                          .e("div", marko_attrs20, "39" + $keyScope$2, component, 1)
                                            .t(name, component)
                                          .e("div", marko_attrs21, "40" + $keyScope$2, component, 1)
                                            .t(description, component);
                                      }
                                    }
                                ]
                            }, out, __component, "34" + $keyScope$2);

                          out.ee();

                          out.ee();
                        });

                        out.ee();
                      }
                    }
                  }, out, __component, "6");

                WSAdapt_tag({
                    class: "col",
                    renderBody: function(out) {
                      Tabs_tag(marko_assign({
                          tabs: Tabs
                        }, learner), out, __component, "42");
                    }
                  }, out, __component, "41");
              }
            }, out, __component, "5");
        }
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
